<template>
  <div id="app" ref="app">
    <router-view></router-view>
    <BackTop />
  </div>
</template>

<script>
import Home from '@/views/Home'


export default {
  name: 'App',
  components: {
    Home,
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

@import url('./assets/css/icon.css');

@media (max-width:768px){
  div[class*="back-top"]{
    width: 26px !important;
    height: 26px !important;
    align-items: center !important;
    justify-content: center !important;
  }
  div[class*="back-top"] i,
  div[class*="back-top"] svg{
    font-size:22px !important;
    width:22px !important;
    height:22px !important;
  }
}
</style>
